export const mobileBannerMessage = 'Design Custom T-shirts & More';
export const desktopBannerMessage = 'Custom T-shirts & Promotional Products, Fast & Free Shipping, and All-Inclusive Pricing';
